const NS = 'ProgramIntakeListBlock';
const CLS = 'programIntakeListBlock';

export class ProgramIntakeListBlock {
	constructor(element) {
		this.element = element;
		this.$appyBtn = $(this.element).find('.programIntakeListBlock-apply');
		this.$list = $(this.element).find('.programIntakeListBlock-list');
		this.$select = $(this.element).find('.programIntakeListBlock-select');
		this.init();
	}

	init() {
		if(this.$appyBtn.data('type') === 'toggle') {
			console.log(112);

			this.$appyBtn.on('click', () => {
				this.$list.toggleClass('d-none d-block');
				this.$select.toggleClass('d-none d-block');
			})

			this.$select.on('change', (e, i) => {
				let value = $('option:selected').val();
				console.log(e,i, value);
				this.filter(value);
			});

		} else {
			return;
		}
	}

	filter(value) {
		if(value == 'all') {
			this.$list.find('.programIntakeListBlock-list-item').css('display', 'block');
			return;
		}

		this.$list.find('.programIntakeListBlock-list-item').each((i, e) => {
			if($(e).data('tag') === value) {
				$(e).css('display', 'block');
			} else {
				$(e).css('display', 'none');
			}
		});
	}
}
